// src/frontend/data/books/BlockchainFundamentals/index.js

import CAP1 from "./data/cap1";
import CAP2 from "./data/cap2";
import CAP3 from "./data/cap3";
import CAP4 from "./data/cap4";
import CAP5 from "./data/cap5";
import CAP6 from "./data/cap6";
import CAP7 from "./data/cap7";
import CAP8 from "./data/cap8";
import CAP9 from "./data/cap9";
import CAP10 from "./data/cap10";
import CAP11 from "./data/cap11";
import CAP12 from "./data/cap12";
import CAP13 from "./data/cap13";


 const BLOCKCHAIN_FUNDAMENTALS_CAPS = {
  cap1: CAP1,
  cap2: CAP2,
  cap3: CAP3,
  cap4: CAP4,
  cap5: CAP5,
  cap6: CAP6,
  cap7: CAP7,
  cap8: CAP8,
  cap9: CAP9,
  cap10: CAP10,
  cap11: CAP11,
  cap12: CAP12,
  cap13: CAP13
};

export default  BLOCKCHAIN_FUNDAMENTALS_CAPS;